import cookie  from './cookie';
import md5 from './md5';
const cookieConfig = {
    aidEncode: 'qd_aid_encode',
};

export function saveLoginAid(aid) {
    try {
        if (aid) {
            let domain;

            if (/qidian.qq.com$/.test(location.host)) {
              domain = 'qidian.qq.com';
              // 30天有效期
              cookie.set(cookieConfig.aidEncode, md5(aid), { expires: 30, domain });
            }
          }
    } catch (e) {
        console.log(e.message);
    }
  }
